import Vue from "vue";
import Vuex from "vuex";

import AccountModule from "./account/AccountModule";
import Audio from "./modules/Audio";
import CompanyModule from "./company/CompanyModule";
import DarkMode from "./modules/DarkMode";
import DateTimePicker from "./modules/DateTimePicker";
import DateTimePickerModule from "./modules/dateTimePicker/DateTimePickerModule";
import EventsRecords from "./modules/EventsRecords";
import EventsSettings from "./modules/EventsSettings";
import EventsTable from "./modules/EventsTable";
import AlarmsLogModule from "@/pages/common/alarm-management/store/AlarmsModule";
import FrequencyTrendLimitConfiguration from "@/pages/common/configurations/frequency-trend-limit-configuration/store/FrequencyTrendLimitConfigurationModule";
import GearBoxBrokenPinionDiagnostic from "./modules/GearBoxBrokenPinionDiagnostic";
import GearboxPlanetaryDiagnostic from "./modules/GearboxPlanetaryDiagnostic";
import GoogleMaps from "./modules/GoogleMaps";
import WindDiagnosticAngularMisalignmentHss from "./modules/WindDiagnosticAngularMisalignmentHss";
import WindDiagnosticParallelMisalignmentHss from "./modules/WindDiagnosticParallelMisalignmentHss";
import HSSMisalignmentDiagnostic from "./modules/HSSMisalignmentDiagnostic";
import GeneratorShaftUnbalanceModule from "./wind/diagnostic/GeneratorShaftUnbalance/GeneratorShaftUnbalanceModule";
import MainShaftUnbalanceModule from "./wind/diagnostic/MainShaftUnbalance/MainShaftUnbalanceModule";
import MainShaftAngularMisalignmentModule from
	"./wind/diagnostic/MainShaftAngularMisalignment/MainShaftAngularMisalignmentModule";
import MainShaftParallelMisalignmentModule from
	"./wind/diagnostic/MainShaftParallelMisalignment/MainShaftParallelMisalignmentModule";
import ResultSets from "./modules/ResultSets";
import RollingBearingFailureDiagnostic from "./modules/RollingBearingFailureDiagnostic";
import RollingBearingLoosenessDiagnostic from "./modules/RollingBearingLoosenessDiagnostic";
import RunTime from "./modules/RunTime";
import Sensors from "./modules/Sensors";
import ToolbarTreeMenuModule from "./tool-bar-menu/ToolbarTreeMenuModule.js";
import Trend from "@/pages/common/trend/store/TrendModule";
import TrendSignal from "./modules/TrendSignal";
import TrendSignalSettings from "./modules/TrendSignalSettings";
import TrendPark from "./modules/TrendPark";
import TriggeredSignal from "./modules/TriggeredSignal";
import UserModule from "./user/UserModule";
import Locale from "./locale/LocaleModule";
import WindTurbineModule from "./wind/turbine/TurbineModule";
import WindDiagnosticTable from "./modules/WindDiagnosticTable";
import WindDiagnosticGeneratorRollingBearingResult from "./modules/WindDiagnosticGeneratorRollingBearingResult";
import WindDiagnosticMainBearingResult from "./modules/WindDiagnosticMainBearingResult";
import WindDiagnosticGearboxStageTwoBrokenTeethResult from "./modules/WindDiagnosticGearboxStageTwoBrokenTeethResult";
import WindDiagnosticLoosenessResult from "./modules/WindDiagnosticLoosenessResult";
import WindDiagnosticGearboxStageThreeBrokenTeethResult from "./modules/WindDiagnosticGearboxStageThreeBrokenTeethResult";
import WindDiagnosticGearboxBearingsResult from "./modules/WindDiagnosticGearboxBearingsResult";
import WindDiagnosticPlanetaryResult from "./modules/WindDiagnosticPlanetaryResult";
import WindISO108162Limits from "./modules/WindISO1081621Limits";
import WindPark from "./modules/WindPark";
import WindParkKPITable from "./modules/WindParkKPITable";
import WindParkSelect from "./modules/WindParkSelect";
import WindRose from "./modules/WindRose";
import WindTurbine from "./modules/WindTurbine";
import WindTurbineReport from "./modules/WindTurbineReport";
import WindTurbinesPerformanceFactor from "./modules/WindTurbinesPerformanceFactor";
import WindTurbinesCapacityFactor from "./modules/WindTurbinesCapacityFactor";
import YearPicker from "./modules/YearPicker";
import ElectricFailModule from "./wind/diagnostic/ElectricFail/ElectricFailModule";
import WindAssetModule from "./asset/wind-environment/WindAssetModule";
import KinematicConfigurationModule from "@/pages/wind/configurations/kinematic/kinematic-configurator/store/KinematicConfiguratorModule";
import KinematicReplicatorModule from "@/pages/wind/configurations/kinematic/kinematic-replicator/store/KinematicReplicatorModule";
import GeneratingUnitFeaturesModule from "../pages/wind/generating-unit/wind-turbine/store/GeneratingUnitFeaturesModule";
import RouterModule from "./router/RouterModule";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		AccountModule,
		Audio,
		CompanyModule,
		DarkMode,
		DateTimePicker,
		DateTimePickerModule,
		ElectricFail:                  ElectricFailModule,
		EventsRecords,
		EventsSettings,
		EventsTable,
		FrequencyTrendLimitConfiguration,
		GearBoxBrokenPinionDiagnostic,
		GearboxPlanetaryDiagnostic,
		GeneratingUnitFeaturesModule,
		GeneratorShaftUnbalance:       GeneratorShaftUnbalanceModule,
		GoogleMaps,
		HSSMisalignmentDiagnostic,
		KinematicConfiguration:        KinematicConfigurationModule,
		KinematicReplicator:           KinematicReplicatorModule,
		Locale,
		MainShaftUnbalance:            MainShaftUnbalanceModule,
		MainShaftAngularMisalignment:  MainShaftAngularMisalignmentModule,
		MainShaftParallelMisalignment: MainShaftParallelMisalignmentModule,
		AlarmsLogModule,
		ResultSets,
		RollingBearingFailureDiagnostic,
		RollingBearingLoosenessDiagnostic,
		RunTime,
		Sensors,
		ToolbarTreeMenuModule,
		Trend,
		TrendSignal,
		TrendSignalSettings,
		TrendPark,
		TriggeredSignal,
		UserModule,
		WindTurbinesPerformanceFactor,
		WindDiagnosticTable,
		WindDiagnosticGeneratorRollingBearingResult,
		WindDiagnosticMainBearingResult,
		WindDiagnosticAngularMisalignmentHss,
		WindDiagnosticParallelMisalignmentHss,
		WindDiagnosticGearboxStageTwoBrokenTeethResult,
		WindDiagnosticLoosenessResult,
		WindDiagnosticGearboxStageThreeBrokenTeethResult,
		WindDiagnosticGearboxBearingsResult,
		WindDiagnosticPlanetaryResult,
		WindISO108162Limits,
		WindTurbine,
		WindTurbineModule,
		WindRose,
		WindPark,
		WindParkSelect,
		WindParkKPITable,
		WindTurbinesCapacityFactor,
		WindTurbineReport,
		WindAssetModule,
		YearPicker,
		RouterModule
	},
});
